import "./matchInformation.sass";
import MatchTimeline from "./matchTimeline/matchTimeline";

export default function MatchInformation({ 
  matchData = null,
  type = "minuto-a-minuto",
  country = null
}) {
  if (!matchData) {
    return null;
  }

  return (
    <div className="match-information-wrapper">

      {/* Timeline de eventos */}
      <div className="match-information-timeline">
        <MatchTimeline
          type={type}
          events={matchData?.events || []}
          homeTeamInfo={matchData?.homeTeamInfo}
          awayTeamInfo={matchData?.awayTeamInfo}
          homeTeamId={matchData?.homeTeam?.id}
          soccerData={matchData?.soccerData}
          period={matchData.periodTitle}
          clase={matchData.status}
          country={country}
        />
      </div>
    </div>
  );
}
